module.exports = __webpack_public_path__ + "static/media/team-member-04.a4fa6ad0.jpg";